import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { extractType } from '@wms/core';
import { toLower } from 'lodash-es';

import { BaseComponent } from '../base/base.component';
import { FieldsListComponent } from '../fields-list/fields-list.component';
import { WmsTreeNodeComponent } from '../wms-tree/wms-tree-node.component';
import { WmsTreeComponent } from '../wms-tree/wms-tree.component';

@Component({
  selector: 'wms-widget-field-tree',
  standalone: true,
  templateUrl: './widget-field-tree.component.html',
  styleUrls: ['./widget-field-tree.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    FieldsListComponent
  ],
  host: {class: 'wms-wizard-body-content'}
})
export class WidgetFieldTreeComponent extends BaseComponent implements OnInit {

  @Input() widgetType!: any;
  @Input() currentStep!: any;
  @Input() otherWdgts!: any;
  @Input() myWidgets!: any;
  @Input() fieldTypeWidgetTypeMap!: any;
  @Input() toggleField!: (field: any) => boolean;
  @Output() selectAllFields = new EventEmitter<any>();
  @Output() updateSelectedComponent = new EventEmitter<any>();
  @Output() updateSelectAll = new EventEmitter<any>();
  @Output() resetDefaultWidgetConfig = new EventEmitter<any>();
  @Output() moveSelectedComponent = new EventEmitter<any>();
  @Output() onWidgetTypeChange = new EventEmitter<any>();
  @Output() toggleInnerFields = new EventEmitter<any>();
  extractTypefunc = extractType;
  toLowerCase = toLower;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
